const state = {
  enableTrialUpgradeReviewFlow: false,
  trialUpgradeRequest: null,
  isSubmittingUpgradeRequest: false,
};

const getters = {
  enableTrialUpgradeReviewFlow(state) {
    return state.enableTrialUpgradeReviewFlow;
  },
  trialUpgradeRequest(state) {
    return state.trialUpgradeRequest;
  },
  isSubmittingUpgradeRequest(state) {
    return state.isSubmittingUpgradeRequest;
  },
};

const actions = {
  updateEnableTrialUpgradeReviewFlow({ commit }, enableTrialUpgradeReviewFlow) {
    commit("UPDATE_ENABLE_TRIAL_UPGRADE_REVIEW_FLOW", enableTrialUpgradeReviewFlow);
  },
  updateTrialUpgradeRequest({ commit }, trialUpgradeRequest) {
    commit("UPDATE_TRIAL_UPGRADE_REQUEST", trialUpgradeRequest);
  },
  updateIsSubmittingUpgradeRequest({ commit }, isSubmittingUpgradeRequest) {
    commit("UPDATE_IS_SUBMITTING_UPGRADE_REQUEST", isSubmittingUpgradeRequest);
  },
};

const mutations = {
  UPDATE_ENABLE_TRIAL_UPGRADE_REVIEW_FLOW(state, enableTrialUpgradeReviewFlow) {
    state.enableTrialUpgradeReviewFlow = enableTrialUpgradeReviewFlow;
  },
  UPDATE_TRIAL_UPGRADE_REQUEST(state, trialUpgradeRequest) {
    state.trialUpgradeRequest = trialUpgradeRequest;
  },
  UPDATE_IS_SUBMITTING_UPGRADE_REQUEST(state, isSubmittingUpgradeRequest) {
    state.isSubmittingUpgradeRequest = isSubmittingUpgradeRequest;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
